import UserService from '../services/user-service';

export default {
  data: () => ({
    isAuth: false,
  }),
  methods: {
    changeIsAuth () {
      this.isAuth = UserService.instance.isAuth;
    },
  },
  beforeMount () {
    this.isAuth = UserService.instance.isAuth;
    UserService.instance.subscribe('logout', this.changeIsAuth.bind(this));
    UserService.instance.subscribe('login', this.changeIsAuth.bind(this));
  },
};
